import PeopleSchemaAdapter from './base';

export default class Group extends PeopleSchemaAdapter {
  modelNamePlural = 'groups';
}
